import type {
  MetroPlusHistoryRecord,
  MetroPlusSendResponse,
  MetroplusRepresentative,
} from './metroPlus.types'

import { ENDPOINTS_TAGS, rootApi } from '@v2/store/api/rootApi'

export const TAGS_METRO_PLUS = {
  Representatives: ENDPOINTS_TAGS.METRO_PLUS_REPRESENTATIVES,
  SendToRecords: ENDPOINTS_TAGS.METRO_PLUS_SEND_TO_RECORDS,
}

export const metroPlusApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getMetroplusRepresentatives: builder.query<MetroplusRepresentative[], void>(
      {
        query: () => ({
          url: '/metro-plus/get-metroplus-reps',
          method: 'GET',
        }),
        providesTags: [TAGS_METRO_PLUS.Representatives],
      },
    ),
    getMetroplusSendToRecords: builder.query<
      MetroPlusHistoryRecord[],
      { personId: string }
    >({
      query: ({ personId }) => ({
        url: `/metro-plus/get-metroplus-send-to/${personId}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { personId }) => [
        { type: TAGS_METRO_PLUS.SendToRecords, id: personId },
      ],
    }),
    sendPersonToMetroplus: builder.mutation<
      MetroPlusSendResponse,
      { personId: string; repEmail: string }
    >({
      query: ({ personId, repEmail }) => ({
        url: `/metro-plus/send-person-metroplus/${personId}`,
        method: 'POST',
        params: { repEmail },
      }),
      invalidatesTags: (_result, _error, { personId }) => [
        { type: TAGS_METRO_PLUS.SendToRecords, id: personId },
      ],
    }),
  }),
})

export const {
  useGetMetroplusRepresentativesQuery,
  useGetMetroplusSendToRecordsQuery,
  useSendPersonToMetroplusMutation,
} = metroPlusApi
